import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B1220] text-slate-300 relative overflow-hidden"
    >
      <div className="absolute inset-0 diag-lines opacity-10" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 bg-white inline-flex p-3">
              <img
                src="/assets/etancia-logo.png"
                alt="ETANCIA — Tous corps d'état"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="mt-5 max-w-md text-slate-400 leading-relaxed">
              Spécialiste étanchéité toitures-terrasses en Île-de-France.
              Gros travaux, interventions rapides et entretien — par des
              professionnels qui aiment le travail bien fait.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="label-kicker text-[#FF5A1F]">Navigation</div>
            <ul className="mt-4 space-y-2 font-display">
              {[
                ["#services", "Services"],
                ["#zone", "Zone d'intervention"],
                ["#realisations", "Réalisations"],
                ["#pourquoi", "Pourquoi nous"],
                ["#contact", "Contact"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a
                    href={h}
                    data-testid={`footer-link-${l.toLowerCase().replace(/\s/g, "-")}`}
                    className="hover:text-[#FF5A1F] transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="label-kicker text-[#FF5A1F]">Contact</div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-slate-500" />
                <a
                  href="tel:0658116161"
                  data-testid="footer-phone"
                  className="hover:text-white"
                >
                  06 58 11 61 61
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-slate-500" />
                <a
                  href="tel:0689764577"
                  data-testid="footer-phone-2"
                  className="hover:text-white"
                >
                  06 89 76 45 77
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-slate-500" />
                <a
                  href="mailto:etancia.pro1@gmail.com"
                  data-testid="footer-email"
                  className="hover:text-white break-all"
                >
                  etancia.pro1@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-slate-500 mt-0.5 shrink-0" />
                <span data-testid="footer-address">
                  Ris-Orangis 91130
                  <br />
                  Île-de-France & alentours
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <p data-testid="footer-legal">
            © {year} ETANCIA · Ris-Orangis 91130 · SIRET 103 617 387 · Tous droits réservés.
          </p>
          <p className="font-display tracking-[0.2em] uppercase text-[10px]">
            Devis gratuit · Garantie décennale · Intervention 24h
          </p>
        </div>
      </div>
    </footer>
  );
}
